import { LogoField, LogoFieldProps } from '@components/logo-field';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormLogoFieldProps<T> = FormFieldProps<LogoFieldProps, T>;

export function FormLogoField<T>(props: FormLogoFieldProps<T>) {
  const formFieldProps = useFormField(props);

  return <LogoField {...props} {...formFieldProps} />;
}
